import config from "../../config";

// Same auth pattern as the app controllers (note the double space — matches authHeader).
function authHeader() {
  const user = JSON.parse(localStorage.getItem("user") || "null");
  if (user && user.key) {
    return { Authorization: "Token  " + user.key };
  }
  return {};
}

async function req(path, { method = "GET", body } = {}) {
  const headers = Object.assign({ "Content-Type": "application/json" }, authHeader());
  const request = new Request(`${config.apiGateway.URL}${path}`, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });
  const response = await fetch(request);
  let json = null;
  try {
    json = await response.json();
  } catch (e) {
    json = null;
  }
  return { json, status: response.status };
}

export const getSubscriptionStatus = (officeId) =>
  req(`/usage/offices/${officeId}/subscription-status/`);

export const getUsageSummary = (officeId) => req(`/usage/offices/${officeId}/usage-summary/`);

export const getInvoices = (officeId, limit = 24) =>
  req(`/usage/offices/${officeId}/invoices/?limit=${limit}`);

/** Quote a plan change. Charges nothing — `confirm` is what bills the card. */
export const previewTierChange = (officeId, tierId) =>
  req(`/usage/offices/${officeId}/change-tier/`, {
    method: "POST",
    body: { subscription_tier_id: tierId, confirm: false },
  });

export const confirmTierChange = (officeId, tierId) =>
  req(`/usage/offices/${officeId}/change-tier/`, {
    method: "POST",
    body: { subscription_tier_id: tierId, confirm: true },
  });

export const previewCancellation = (officeId) => req(`/usage/offices/${officeId}/cancel/preview/`);

export const confirmCancellation = (officeId) =>
  req(`/usage/offices/${officeId}/cancel/`, {
    method: "POST",
    body: { confirm_penalty: true },
  });

/**
 * Download one receipt.
 *
 * Not a plain <a href>: the endpoint is token-authenticated, so a bare link would
 * arrive unauthenticated and 401. Fetch it with the header, then hand the browser
 * a blob.
 */
export async function downloadInvoicePdf(officeId, transactionId, filename) {
  const request = new Request(
    `${config.apiGateway.URL}/usage/offices/${officeId}/invoices/${transactionId}/pdf/`,
    { method: "GET", headers: authHeader() }
  );
  const response = await fetch(request);
  if (!response.ok) return { ok: false, status: response.status };

  const blob = await response.blob();
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename || `smilepass-receipt-${transactionId}.pdf`;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  // Revoke on the next tick: revoking synchronously can beat the download in
  // Safari and produce an empty file.
  setTimeout(() => window.URL.revokeObjectURL(url), 1000);
  return { ok: true, status: response.status };
}
